export default __webpack_public_path__ + "4ac82c8a9c96b83c4df6b89ef364ad58.png";